import * as Yup from "yup";

export const SignInScheme = Yup.object().shape({
  email: Yup.string().required("Please enter your email address")
});